import { Goods } from "../scrollWatch"
const projectScroll = (scroll) => {
    scroll('custom-project', function (flag) {
        const { showTime, join } = flag
        Goods.dispatch('customProject', { showTime: showTime })
    })
}

export default projectScroll